<template>
  <CCard class="my-4">
    <div class="px-5 py-4 border-bottom">
      <p class="font-3xl font-weight-bold mb-3">{{ $t('automation.statistics.key-metrics.title') }}</p>
      <span class="text-gray-500">{{ $t('automation.statistics.key-metrics.description.creation-date') }}</span>
    </div>
    <div class="p-4 flex-1">
      <div v-if="isLoadingData" class="w-100 text-center">
        <CSpinner class="d-inline-block" style="width: 60px; height: 60px" />
      </div>
      <div class="h-100" v-else>
        <template v-if="hasStatisticsData">
          <AutomationStatisticsGeneralCard
            v-for="statisticProperty in statisticsProperties"
            :key="statisticProperty.type"
            :cardType="statisticProperty.type"
            :highlightValue="statisticProperty.value"
          />
        </template>
        <div class="h-100 d-flex justify-content-center align-items-center" v-else>
          <EmptyMessage />
        </div>
      </div>
    </div>
  </CCard>
</template>
<script>
import AutomationStatisticsGeneralCard from './AutomationStatisticsGeneralCard.vue'
import { STATISTICS_TYPES } from '../constants'
import EmptyMessage from '@/components/EmptyMessage.vue'

export default {
  name: 'AutomationStatisticsGeneral',
  components: { AutomationStatisticsGeneralCard, EmptyMessage },
  props: {
    statisticsProperties: {
      type: Array,
      default: () => ([]),
    },
    isLoadingData: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      STATISTICS_TYPES: STATISTICS_TYPES,
    }
  },
  computed: {
    hasStatisticsData() {
      return this.statisticsProperties.some((property) => property.value !== 0)
    },
  },
}
</script>

<style lang="scss" scoped>
.d-contents {
  display: contents;
}
.flex-1 {
  flex: 1
}
</style>